import _toPrimitive from "../internals/to-primitive";
import _isSymbol from "../internals/is-symbol";
var exports = {};
var toPrimitive = _toPrimitive;
var isSymbol = _isSymbol;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
exports = function (argument) {
  var key = toPrimitive(argument, "string");
  return isSymbol(key) ? key : key + "";
};
export default exports;